import React from 'react'
import CellContent from './CellContent'
import FlashCancellationPolicies from 'components/Common/CancellationPolicies/Flash/FlashCancellationPolicies'
import TAOCancellationPolicies from 'components/Common/CancellationPolicies/AlwaysOn/TAOCancellationPolicies'

interface Props {
  offer: App.HotelOffer
  params: App.OfferComparisonOfferParams
}

function LeHotelCartCancellationPolicyCell({ offer, params }: Props) {
  const { filters, packageUniqueKey } = params
  const checkIn = filters?.checkIn
  const checkOut = filters?.checkOut
  const selectedPackage = offer.packages.find(p => p.uniqueKey === packageUniqueKey)
  const cancellationPolicyType = selectedPackage?.roomRate?.cancellationPolicy?.type
  const useDynamicCancellationPolicies = offer.property?.useDynamicCancellationPolicies ?? false
  const ignoreDynamicCancellationPolicy = selectedPackage?.ignoreDynamicCancellationPolicy ?? false

  return (
    <CellContent>
      {cancellationPolicyType && offer.type === 'hotel' && <FlashCancellationPolicies
        checkInDate={checkIn}
        propertyTimezoneOffset={offer.property.timezoneOffset}
        cancellationPolicy={selectedPackage.roomRate.cancellationPolicy}
      />}
      {cancellationPolicyType && offer.type === 'tactical_ao_hotel' && <TAOCancellationPolicies
        offerId={offer.id}
        useDynamicCancellationPolicies={useDynamicCancellationPolicies && !ignoreDynamicCancellationPolicy}
        timezoneOffset={offer.property?.timezoneOffset}
        uniqueKey={selectedPackage.uniqueKey}
        checkInDate={checkIn}
        checkOutDate={checkOut}
        occupants={filters?.rooms}
        cancellationPolicy={selectedPackage.roomRate?.cancellationPolicy}
        offerType={offer.type}
      />}
    </CellContent>
  )
}

export default LeHotelCartCancellationPolicyCell
